import { createAppAsyncThunk } from '@/redux/create-app-thunk';

export const loadSensefuel = createAppAsyncThunk(
  'configuration/loadSensefuel',
  async (_, { getState, extra: { configurationService } }) => {
    const sensefuelIdFromState = getState().root.storeConf.sensefuelId;
    try {
      return await configurationService.loadSensefuel(sensefuelIdFromState);
    } catch (error) {
      console.error('ConfigurationService => loadSensefuel: ', error.message);
    }
  });
